import React from 'react';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import { useAppSelector } from 'src/app/hooks';
import AsmubipButton from './AsmubipButton';
import { Layout } from 'src/styles';
import { getWhatsAppUrl } from 'src/utils/utils';

type WhatsAppHelpButtonProps = {
  phoneNumber?: string;
  message?: string;
};

export default function WhatsAppHelpButton({ phoneNumber, message }: WhatsAppHelpButtonProps) {
  const { isMobile } = useAppSelector((state) => state.page);

  const whatsappUrl = getWhatsAppUrl({ isMobile, phoneNumber, message });

  const target = isMobile ? undefined : '_blank';

  return (
    <AsmubipButton
      component="a"
      href={whatsappUrl}
      rel="noopener noreferrer"
      {...(target ? { target } : {})}
      variant="contained"
      endIcon={<WhatsAppIcon sx={Layout.bottomBarButtons} />}>
      Ajuda
    </AsmubipButton>
  );
}
